<div class="footer__change-language-dropdown dropdown-wrapper p-0 md:flex md:align-self-center">
  <div class="decorated-dropdown inline-block">
    <p-dropdown
      [ngModel]="currentLanguage()"
      [options]="languages()"
      [dropdownIcon]="''"
      (onChange)="onChangeLanguage($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedLanguage>
        <div class="flex gap-2">
          <i class="ax-las la-language-globe"></i>

          <div class="flex gap-1 font-medium" data-nested-translation="footer.dropdown.language.label">
            <span>{{ 'footer.dropdown.language.label' | translate }}</span>
            <span>{{ 'footer.dropdown.language.option.' + selectedLanguage | translate }}</span>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="item" let-languageCode>
        <span class="p-dropdown-item-option">
          {{ 'footer.dropdown.language.option.' + languageCode | translate }}
        </span>
      </ng-template>
    </p-dropdown>
  </div>
</div>
